const autoFocus = (inputId: string) => {
  const inputName = document.getElementById(inputId);

  if (inputName) {
    inputName.focus();
  }
};

export default autoFocus;
